module.exports = __webpack_public_path__ + "static/media/stress.3a7033ff.svg";